module.exports = __webpack_public_path__ + "static/media/resume.8a5f782f.pdf";